export const getCampaignFilter = state => state.campaign.filter

export const getCampaignGroupFilter = state => state.campaignGroup.filter

export const getCampaignTypeFilter = state => state.campaignType.filter
